<ng-container *transloco="let t">
    <button
        *ngIf="!isCartShared(); else addMoreMembersTmpl"
        tuiButton
        (click)="shareOrder()"
        appearance="outline"
        [size]="size"
    >
        <tui-svg [src]="'tuiIconUserPlus'"></tui-svg>
        <!-- {{ t('place_a_group_order') }} -->
    </button>

    <ng-template #addMoreMembersTmpl>
        <div tuiGroup [collapsed]="true" (click)="showAddMoreMemberDialog()">
            <button appearance="outline" size="s" tuiButton type="button">
                <tui-svg [src]="'tuiIconUsers'"></tui-svg>
                <span class="font-medium text-base mx-1">{{ memberCount() }}</span>
            </button>
            <button
                appearance="outline"
                [icon]="'tuiIconPlus'"
                size="s"
                tuiIconButton
                type="button"
                class="!flex-none"
            ></button>
        </div>

        <!--<a class="flex gap-2" (click)="showAddMoreMemberDialog()">
            <div class="pr-2">
                <div class="tui-avatar-stack">
                    <tui-avatar
                        *ngFor="let member of members(); trackByProperty: 'id'"
                        [autoColor]="true"
                        [size]="size"
                        [text]="member.name"
                    ></tui-avatar>
                </div>
            </div>

            <button tuiButton appearance="outline" [size]="size">
                <tui-svg [src]="'tuiIconUserPlus'"></tui-svg>
                {{ 'invite_more' | transloco }}
            </button>
        </a>-->
    </ng-template>
</ng-container>
